import StepperHeaderContainer from './styles';

export default StepperHeaderContainer;
